import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'md',
    boxShadow:
      '0px 4px 8px 0px rgba(0, 0, 0, 0.25), 0px 0px 20px 0px rgba(0, 216, 255, 0.15) inset, 0px 0px 0px 1px rgba(149, 239, 255, 0.2) inset',
    overflow: 'hidden',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'md',
    m: '1px',
    mb: '0',
    bg: 'rgba(34, 92, 161, 0.5)',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textTransform: 'uppercase',
    textAlign: 'left',
    fontFamily: 'body',
    fontSize: 'xs',
    fontWeight: 'bold',
    color: 'white',
  },
  footerFlex: {
    as: 'footer',
    bg: 'alpha.400',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.300',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'lg',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'blackAlpha.400',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'beta.300',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    color: 'white',
    fontWeight: 'normal',
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'capitalize',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
    sx: {
      svg: {
        color: 'beta.300',
      },
    },
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'normal',
    color: 'white',
    fontFamily: 'body',
  },
  footerMatchLinkIcon: {
    color: 'white',
    fontSize: 'md',
  },
};
